module.exports = __webpack_public_path__ + "img/expired.49f74f4f.png";